import { z } from 'zod'

export function getDefaults<Schema extends z.AnyZodObject>(
  schema: Schema
): z.infer<Schema> {
  return Object.fromEntries(
    Object.entries(schema.shape).map(([key, value]) => {
      if (value instanceof z.ZodDefault) return [key, value._def.defaultValue()]
      return [key, undefined]
    })
  ) as z.infer<Schema>
}

export function getRankSuffix(rank: number): string {
  const j = rank % 10
  const k = rank % 100

  let suffix = 'th'
  if (j === 1 && k !== 11) suffix = 'st'
  else if (j === 2 && k !== 12) suffix = 'nd'
  else if (j === 3 && k !== 13) suffix = 'rd'

  return suffix
}

export function formatDateString(dateString: string): string {
  const date = new Date(dateString)
  return date.toUTCString()
}
